import { JSON } from '../utils/types'

import BankSlip from './BankSlip'
import BankTransfer from './BankTransfer'
import Breb from './Breb'
import Deuna from './Deuna'
import Mach from './Mach'
import Nequi from './Nequi'
import Oxxo from './Oxxo'
import PagoEfectivo from './PagoEfectivo'
import PayCash from './PayCash'
import PicPay from './PicPay'
import Pix from './Pix'
import PixAutomatico from './PixAutomatico'
import QrInteroperable from './QrInteroperable'
import Spei from './Spei'
import TiendasYFarmacias from './TiendasYFarmacias'

export default class CheckoutSuccess {
  bankSlip?: BankSlip

  pix?: Pix

  pixAutomatico?: PixAutomatico

  oxxo?: Oxxo

  paynet?: TiendasYFarmacias

  tiendasYFarmacias?: TiendasYFarmacias

  spei?: Spei

  paycash?: PayCash

  picpay?: PicPay

  bankTransfer?: BankTransfer

  pagoEfectivo?: PagoEfectivo

  deuna?: Deuna

  nequi?: Nequi

  mach?: Mach

  qrInteroperable?: QrInteroperable

  breb?: Breb

  paymentToken: string

  referenceId: string

  publicCardId?: string

  publicPersonId?: string

  redirectUrl: string

  subscriptionId: string

  subscriptionReferenceId: string

  checkoutId?: string

  constructor(response: JSON) {
    if (response.boleto) {
      this.bankSlip = new BankSlip(response.boleto)
    }
    if (response.pix) {
      this.pix = new Pix(response.pix)
    }
    if (response.pix_automatico) {
      this.pixAutomatico = new PixAutomatico(response.pix_automatico)
    }
    if (response.oxxo) {
      this.oxxo = new Oxxo(response.oxxo)
    }
    if (response.paynet) {
      this.paynet = new TiendasYFarmacias(response.paynet)
    }
    if (response.tiendas_y_farmacias) {
      this.tiendasYFarmacias = new TiendasYFarmacias(response.tiendas_y_farmacias)
    }
    if (response.spei) {
      this.spei = new Spei(response.spei)
    }
    if (response.paycash) {
      this.paycash = new PayCash(response.paycash)
    }
    if (response.picpay) {
      this.picpay = new PicPay(response.picpay)
    }
    if (response.bank_transfer) {
      this.bankTransfer = new BankTransfer(response.bank_transfer)
    }
    if (response.pago_efectivo) {
      this.pagoEfectivo = new PagoEfectivo(response.pago_efectivo)
    }
    if (response.deuna) {
      this.deuna = new Deuna(response.deuna)
    }
    if (response.nequi) {
      this.nequi = new Nequi(response.nequi)
    }
    if (response.mach) {
      this.mach = new Mach(response.mach)
    }
    if (response.qr_interoperable) {
      this.qrInteroperable = new QrInteroperable(response.qr_interoperable)
    }
    if (response.breb) {
      this.breb = new Breb(response.breb)
    }
    this.paymentToken = response.payment_token
    this.referenceId = response.reference_id
    this.publicCardId = response.public_card_id
    this.publicPersonId = response.public_person_id
    this.redirectUrl = response.redirect_url
    this.subscriptionId = response.subscription_id
    this.subscriptionReferenceId = response.subscription_reference_id
    this.checkoutId = response.checkout_id
  }
}
